/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from 'react'
import {
  View,
  FlatList,
  ScrollView,
  TouchableOpacity,
  ImageBackground,
  StatusBar,
  BackHandler,
  Platform,
} from 'react-native'
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context'
import ContentLoader, { Rect } from 'react-content-loader/native'
import PropTypes from 'prop-types'
import { Icon } from '@vfgroup-oneplatform/foundation/Components'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { lowerCase } from 'lodash'

import VfText from '../../Components/VfText'
import VFButton from '../../Components/VFButton'
import Browser from '../../Components/Browser'

import images from '../../Themes/Images'
import styles, { itemStyles } from './GigaFamily.Styles'


console.disableYellowBox = true
const views = {
  tv: 'GigaProductInfo',
  fiber: 'GigaProductInfo',
  gigaBonus: 'GigaBonus',
}
const ICONS = {
  myPlan: images.mobileDualTone,
  gigaBonus: images.gigaBonus,
  support: images.support,
}

function Card({
  coverImage,
  tags,
  onPress,
  ctaTitle,
  title,
  sectionTitle,
  isContentLoading,
}) {
  const [isBgLoading, setBgLoading] = useState(true)

  return (
    <View style={itemStyles.wrapper}>
      <VfText
        i18nKey={sectionTitle}
        size="h3"
        weight="bold"
        style={itemStyles.sectinTitle}
      />
      <View style={itemStyles.cardContainer}>
        <View style={itemStyles.card}>
          <TouchableOpacity onPress={onPress} activeOpacity={0.6}>
            <ImageBackground
              source={coverImage}
              resizeMode="cover"
              style={itemStyles.cover}
              onLoad={() => setBgLoading(false)}>
              {isBgLoading ? (
                <ContentLoader
                  speed={2}
                  width={'100%'}
                  height={'100%'}
                  backgroundColor={Colors.offWhite}
                  foregroundColor={Colors.veryLightPinkTwo}>
                  <Rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
                </ContentLoader>
              ) : null}
            </ImageBackground>
            <View style={itemStyles.details}>
              <VfText
                i18nKey={title}
                size="h3"
                weight="bold"
                numberOfLines={2}
              />
              <View style={itemStyles.cta}>
                <VfText
                  i18nKey={ctaTitle}
                  size="footnote"
                  isLoading={isContentLoading}
                />
                <Icon
                  name={images.chevronRight}
                  type="image"
                  resizeMode="contain"
                  size={18}
                  style={itemStyles.ctaIcon}
                />
              </View>
            </View>
          </TouchableOpacity>
          <FlatList
            horizontal
            showsHorizontalScrollIndicator={false}
            style={itemStyles.listContainer}
            contentContainerStyle={itemStyles.listContent}
            data={tags || []}
            renderItem={({ item, index }) => (
              <VfText
                key={'benefit-' + index}
                i18nKey={item}
                size="footnote"
                color={Colors.thinDark}
                style={itemStyles.inCoverInfo}
              />
            )}
          />
        </View>
      </View>
    </View>
  )
}
Card.propTypes = {
  coverImage: PropTypes.any,
  tags: PropTypes.arrayOf(PropTypes.string),
  onPress: PropTypes.func,
  ctaTitle: PropTypes.string,
  title: PropTypes.string,
  sectionTitle: PropTypes.string,
  isContentLoading: PropTypes.bool,
}

const CardPlaceholder = memo(function card() {
  return (
    <View style={itemStyles.wrapper}>
      <VfText
        size="h3"
        weight="bold"
        style={itemStyles.placeholderTitle}
        isLoading
        loadingBackgroundColor={Colors.offWhite}
        loadingForegroundColor={Colors.veryLightPinkTwo}
      />
      <View style={itemStyles.cardContainer}>
        <View style={itemStyles.card}>
          <TouchableOpacity disabled>
            <ContentLoader
              speed={2}
              width={'100%'}
              height={152}
              backgroundColor={Colors.offWhite}
              foregroundColor={Colors.veryLightPinkTwo}>
              <Rect x="0" y="0" rx="0" ry="0" width="100%" height="152" />
            </ContentLoader>
            <View style={itemStyles.details}>
              <VfText
                size="h3"
                weight="bold"
                numberOfLines={2}
                isLoading
                style={itemStyles.placeholderDesc}
                loadingBackgroundColor={Colors.offWhite}
                loadingForegroundColor={Colors.veryLightPinkTwo}
              />
              <TouchableOpacity disabled style={itemStyles.cta}>
                <VfText
                  size="footnote"
                  isLoading
                  style={itemStyles.placeholderCta}
                  loadingBackgroundColor={Colors.offWhite}
                  loadingForegroundColor={Colors.veryLightPinkTwo}
                />
                <Icon
                  name={images.chevronRight}
                  type="image"
                  resizeMode="contain"
                  size={18}
                  style={itemStyles.ctaIcon}
                />
              </TouchableOpacity>
            </View>
          </TouchableOpacity>
          <FlatList
            horizontal
            showsHorizontalScrollIndicator={false}
            style={itemStyles.listContainer}
            contentContainerStyle={itemStyles.listContent}
            data={[{}]}
            renderItem={({ index }) => (
              <VfText
                key={'benefitHolder-' + index}
                size="footnote"
                color={Colors.thinDark}
                style={itemStyles.placeholderInCoverInfo}
                isLoading
                loadingBackgroundColor={Colors.white}
                loadingForegroundColor={Colors.veryLightPinkTwo}
              />
            )}
          />
        </View>
      </View>
    </View>
  )
})

function SmallCard({ icon, onPress, tags, title, sectionTitle, isContentLoading }) {
  const [tagsList, setTagsList] = useState('')

  const reducer = (acc, cur, idx) => {
    if (idx === 0) {
      return acc + cur
    }
    return acc + ', ' + cur
  }

  useEffect(() => {
    setTagsList(tags.reduce(reducer, ''))
  }, [tags])

  return (
    <View style={itemStyles.wrapper}>
      <VfText
        i18nKey={sectionTitle}
        size="h3"
        weight="bold"
        style={itemStyles.sectinTitle}
      />
      <View style={itemStyles.cardContainer}>
        <View style={itemStyles.card}>
          <TouchableOpacity
            onPress={onPress}
            activeOpacity={0.6}
            style={itemStyles.touchable}>
            <Icon
              name={icon}
              type="image"
              resizeMode="contain"
              size={32}
              style={itemStyles.leftIcon}
            />
            <View style={itemStyles.detailsContainer}>
              <VfText
                i18nKey={title}
                size="h3"
                weight="bold"
                numberOfLines={2}
                isLoading={isContentLoading}
                localize={false}
                loadingBackgroundColor={Colors.offWhite}
                loadingForegroundColor={Colors.veryLightPinkTwo}
              />
              <VfText
                i18nKey={tagsList}
                color={Colors.thinDark}
              />
            </View>
            <Icon
              name={images.chevronRight}
              type="image"
              resizeMode="contain"
              size={24}
              style={itemStyles.rightIcon}
            />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  )
}
SmallCard.defaultProps = {
  tags: [],
}
SmallCard.propTypes = {
  icon: PropTypes.any,
  onPress: PropTypes.func,
  tags: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  sectionTitle: PropTypes.string,
  isContentLoading: PropTypes.bool,
}

function MyPlan({ goToAccount, getCustomerPlan, plan, ...props }) {
  const [planLoading, setPlanLoading] = useState(true)
  useEffect(() => {
    setPlanLoading(true)
    getCustomerPlan?.({
      onSuccess: () => setPlanLoading(false),
      onError: () => setPlanLoading(false),
    })
  }, [])

  return (
    <SmallCard
      {...props}
      title={plan}
      onPress={goToAccount}
      isContentLoading={planLoading}
    />
  )
}
MyPlan.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
  goToAccount: PropTypes.func,
  getCustomerPlan: PropTypes.func,
  plan: PropTypes.string,
}

const CARD_VIEWS = {
  plan: MyPlan,
  small: SmallCard,
  normal: Card,
  undefined: Card,
}

function GigaFamily({
  navigation: { navigate },
  isContentLoading,
  getCustomerPlan,
  plan,
  getProducts,
  title,
  products,
  isGigaFamily,
  productsLoading,
  onClose,
  navigateToAccount,
  openEbil,
}) {

  const changeStatusBar = (barStyle = 'light-content', backgroundColor = Colors.transparent, translucent = true) => {
    StatusBar.setBarStyle(barStyle, true)
    if (Platform.OS === 'android') {
      StatusBar.setBackgroundColor(backgroundColor, true)
      StatusBar.setTranslucent(translucent)
    }
  }

  useEffect(() => {
    getProducts?.()
    changeStatusBar()
  }, [])

  const insets = useSafeAreaInsets()

  const [browserState, setBrowserState] = useState({
    isVisible: false,
    url: '',
  })
  const openBrowser = (urlKey, contentManager = false, placeholders = []) => {
    const url = contentManager
      ? ContentManager.translate(urlKey, placeholders)
      : urlKey
    setBrowserState({
      isVisible: true,
      url: url,
    })
    changeStatusBar('dark-content', Colors.whiteSmoke)
  }
  const closeBrowser = () => {
    setBrowserState({
      isVisible: false,
      url: '',
    })
    changeStatusBar('light-content', Colors.transparent)
  }

  function isValidURL(str) {
    var pattern = /^https?:\/\/.*/
    return !!pattern.test(str)
  }

  function onPress(item) {
    const redirect = item.redirect_view
    if (isValidURL(redirect)) {
      openBrowser(redirect)
    } else {
      if (Object.keys(views).includes(redirect)) {
        navigate(views[redirect], { item, title })
      }
    }
  }

  const closeScreen = () => {
    resetStatusBar()
    onClose()
  }

  const goToAccount = () => {
    resetStatusBar()
    navigateToAccount()
  }

  const resetStatusBar = () => {
    changeStatusBar(Platform.OS === 'android' ? 'light-content' : 'dark-content', Colors.thinDark, false)
  }

  useEffect(() => {
    const backAction = () => {
      resetStatusBar()
      return false
    }
    const backHandler = BackHandler.addEventListener(
      'hardwareBackPress',
      backAction
    )
    return () => backHandler.remove()
  }, [])

  return (
    <View style={styles.screenWrapper}>
      <StatusBar
        translucent
        barStyle="light-content"
        backgroundColor={Colors.transparent}
        animated
      />
      <View style={styles.headerBackground(insets.top)} />
      <SafeAreaView style={styles.container} edges={['top', 'right', 'left']}>
        <View style={styles.headerWrapper}>
          <View style={styles.header}>
            <View style={styles.headerContentWrapper}>
              <View style={styles.empty} />

              {lowerCase(title) === 'giga family'
                ? <Icon
                  name={images.GFLogo}
                  type="image"
                  width={120}
                  height={40}
                  resizeMode="contain"
                  style={{
                    ...Platform.select({
                      web: {
                        width: 120,
                        height: 40
                      },
                      default: {}
                    })
                  }}
                />
                : <VfText
                  i18nKey={title || ''}
                  size="h5"
                  color={Colors.white}
                  isLoading={productsLoading}
                />
              }

              <TouchableOpacity onPress={closeScreen} disabled={!onClose}>
                <Icon
                  name={images.close}
                  type="image"
                  resizeMode="contain"
                  size={24}
                  style={styles.closeIcon}
                />
              </TouchableOpacity>
            </View>
          </View>
        </View>
        <ScrollView
          showsVerticalScrollIndicator={false}
          style={styles.scrollContainer}
          contentContainerStyle={styles.scrollContentContainer(insets.bottom)}>
          {productsLoading ? (
            <>
              <CardPlaceholder key="placeholder-1" />
              <CardPlaceholder key="placeholder-2" />
            </>
          ) : (
            products?.map((product, index) => {
              const CardView = CARD_VIEWS[product.card_type] || Card
              return (
                <CardView
                  key={'product-' + index}
                  icon={ICONS[product.image_url]}
                  coverImage={{ uri: product.image_url }}
                  tags={product.tags}
                  ctaTitle="giga_more_info"
                  onPress={() => onPress(product)}
                  goToAccount={goToAccount}
                  getCustomerPlan={getCustomerPlan}
                  plan={plan}
                  title={product.desc}
                  sectionTitle={product.name}
                  isContentLoading={isContentLoading}
                />
              )
            })
          )}
          {Boolean(isGigaFamily) && (
            <View style={styles.buttonContainer}>
              <VFButton
                type="primary"
                title="giga_pay_next_plan"
                onPress={openEbil}
                disabled={false}
              />
              <VFButton
                type="secondary"
                title="giga_pay_fiber_tv"
                onPress={() => openBrowser('giga_link_abcom', true)}
                disabled={false}
                style={styles.button}
              />
            </View>
          )}
        </ScrollView>
        <Browser browserState={browserState} closeBrowser={closeBrowser} />
      </SafeAreaView>
    </View>
  )
}

GigaFamily.defaultProps = {
  getCustomerPlan: () => alert('111'),
}

GigaFamily.propTypes = {
  navigation: PropTypes.object,
  isContentLoading: PropTypes.bool,
  getCustomerPlan: PropTypes.func,
  plan: PropTypes.string,
  getProducts: PropTypes.func,
  title: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.object),
  isGigaFamily: PropTypes.bool,
  productsLoading: PropTypes.bool,
  productsError: PropTypes.string,
  onClose: PropTypes.func,
  navigateToAccount: PropTypes.func,
  openEbil: PropTypes.func,
}

export default GigaFamily
